import { Box, Icon, ListItemIcon, MenuItem, Typography } from "@mui/material";
import { useContext, useEffect, useState } from "react";
import { Link, matchPath } from "react-router-dom";
import { MenuDefinition } from "../../constants/MenuConstants";
import { IntegrationContext } from "../../contexts/IntegrationContext";

export default function AppBarSubMenuItem(props: {
    menuItem: MenuDefinition;
    handleCloseMenu: () => void;
}) {
    const [badgeCount, setBadgeCount] = useState<number | string | null>(null);

    const integrationContext = useContext(IntegrationContext);

    useEffect(() => {
        if (integrationContext.badgeNeedsRefresh) {
            getBadgeCountIfNeeded();
        }
    }, [integrationContext.badgeNeedsRefresh]);

    const getBadgeCountIfNeeded = async () => {
        if (props.menuItem.badgeCountResolver) {
            const result = await props.menuItem.badgeCountResolver();
            setBadgeCount(result);
        }
    };

    const childMatch = matchPath(window.location.pathname, props.menuItem.url);

    return (
        <Link to={props.menuItem.url} style={{ textDecoration: "none" }}>
            <MenuItem sx={{ px: 2, py: 1.5 }} onClick={props.handleCloseMenu}>
                <ListItemIcon>
                    <Icon color={childMatch ? "primary" : "disabled"}>
                        {props.menuItem.icon}
                    </Icon>
                </ListItemIcon>
                <Typography color={childMatch ? "primary" : "text.secondary"}>
                    {props.menuItem.title}
                </Typography>

                <Box flexGrow={1} />

                {badgeCount && (
                    <Typography color="error" fontSize="smaller">
                        {badgeCount}
                    </Typography>
                )}
            </MenuItem>
        </Link>
    );
}
